module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAOCAYAAADuQ3ZcAAAAEElEQVQYV2O4efPmfwZKCQDDpjGN1lfwawAAAABJRU5ErkJggg=="